module.exports = __webpack_public_path__ + "img/d- (20).4138113a.png";